import { INavBarState } from '../../types';
import { Types } from '../actions/navbar-actions';

const navbarReducer = (state: INavBarState, action: any): INavBarState => {
  switch (action.type) {
    case Types.SET_NAVBAR_TITLE:
      return { ...state, navbarTitle: action.data };
    case Types.SET_VEHICLE_POLICY_DETAILS_SECTION:
      return { ...state, showPolicyDetails: action.data };
    case Types.SET_UPDATE_MARKET_SCAN_POPUP:
      return { ...state, showUpdateMarketScanPopup: action.data };
    default:
      return state;
  }
};

export default navbarReducer;
